import { Skeleton } from '@/common/components/ui/skeleton';

export const FormPageSkeleton = () => (
  <div className="flex flex-col gap-8">
    <div className="flex flex-col gap-1">
      <Skeleton className="h-8 max-w-[400px] w-full" />
      <Skeleton className="h-5 max-w-[300px] w-full" />
    </div>
    <Skeleton className="h-[400px] w-full rounded-lg" />
  </div>
);
